import { Icon20CopyOutline, Icon20RectangleInfoOutline } from '@vkontakte/icons';
import React, { type ReactElement, useEffect, useRef, useState } from 'react';
import type { IAdChoice } from 'reactApp/modules/promo/promo.types';
import { copy } from 'reactApp/utils/copyToClipboard';

import styles from './AdChoicePopover.css';

interface AdChoicePopoverProps {
    isOpen: boolean;
    onClose: () => void;
    adchoice: IAdChoice;
    children: ReactElement;
}

export const AdChoicePopover = React.memo(function AdChoicePopover(props: AdChoicePopoverProps): ReactElement {
    const { isOpen, onClose, adchoice, children } = props;

    const [isCopied, setIsCopied] = useState(false);
    const element = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const onDocumentClick = (event: MouseEvent) => {
            if (element && element.current && !element.current.contains(event.target as Node) && isOpen) {
                onClose();
            }
        };

        document.addEventListener('click', onDocumentClick);

        return () => {
            document.removeEventListener('click', onDocumentClick);
        };
    }, [isOpen]);

    const onCopy = () => {
        if (!isCopied) {
            copy(adchoice.copy.value);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 1500);
        }
    };

    return (
        <div className={styles.adChoice}>
            {children}
            {isOpen && (
                <div className={styles.adPopover} ref={element}>
                    <div className={styles.filterBackdrop} />
                    <div className={styles.adPopoverContent}>
                        <div className={styles.title}>{adchoice.title}</div>
                        <a href={adchoice.link.value} target="_blank" rel="noopener noreferrer" className={styles.item}>
                            <Icon20RectangleInfoOutline />
                            {adchoice.link.name}
                        </a>
                        <div onClick={onCopy} className={styles.item}>
                            <Icon20CopyOutline />
                            {isCopied ? 'Скопировано' : `ERID: ${adchoice.copy.value}`}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
});
